var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin-top: 24px;\n'], ['\n  text-align: center;\n  margin-top: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: #979797;\n  font-size: 14px;\n  line-height: 27px;\n  margin-bottom: 50px;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  width: 100%;\n  p {\n    color: #979797;\n  }\n  span {\n    white-space: nowrap;\n    @media (max-width: 768px) {\n      white-space: normal;\n    }\n  }\n  a {\n    white-space: nowrap;\n    color: #eb3158;\n    @media (max-width: 768px) {\n      white-space: normal;\n    }\n  }\n'], ['\n  color: #979797;\n  font-size: 14px;\n  line-height: 27px;\n  margin-bottom: 50px;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  width: 100%;\n  p {\n    color: #979797;\n  }\n  span {\n    white-space: nowrap;\n    @media (max-width: 768px) {\n      white-space: normal;\n    }\n  }\n  a {\n    white-space: nowrap;\n    color: #eb3158;\n    @media (max-width: 768px) {\n      white-space: normal;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: 100vw;\n'], ['\n  width: 100%;\n  max-width: 100vw;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  height: 20px;\n  display: flex;\n  width: 100%;\n  max-width: 100vw;\n'], ['\n  height: 20px;\n  display: flex;\n  width: 100%;\n  max-width: 100vw;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  display: flex;\n  flex: 1 0;\n  height: 20px;\n'], ['\n  background-color: ', ';\n  display: flex;\n  flex: 1 0;\n  height: 20px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Outer = styled.footer(_templateObject);
var FooterText = styled.div(_templateObject2);
var Container = styled.div(_templateObject3);
var Stripes = styled.div(_templateObject4);
var Stripe = styled.div(_templateObject5, function (props) {
  return props.colour;
});

var ABSA_Footer = function ABSA_Footer(props) {
  return React.createElement(Outer, null, React.createElement(FooterText, null, React.createElement('a', {
    href: 'https://www.absa.co.za/legal-and-compliance/terms-of-use/'
  }, 'Terms Of Use'), ' | ', " ", React.createElement('a', {
    href: 'https://www.absa.co.za/about-us/absa-bank/corporate-information/'
  }, 'Banking Regulations'), ' | ', " ", React.createElement('a', {
    href: 'https://www.absa.co.za/legal-and-compliance/privacy-policy/'
  }, 'Privacy Policy'), ' | ', " ", React.createElement('a', {
    href: 'https://www.absa.co.za/security-centre/'
  }, 'Security Centre'), ' | \xA9 Copyright. Absa Bank Limited, Registration number 1986/004794/06. All rights reserved | ', React.createElement('a', {
    href: 'https://www.absa.co.za/about-us/absa-bank/corporate-information/'
  }, 'Authorised Financial Services Provider and a registered credit provider (NCRCP7)'), ' | ', React.createElement('span', null, 'Absa Life Limited FSP 36116'), ' | ', React.createElement('p', null, 'Employee Care Plan is underwritten by Absa Life Limited, Reg No: 1992/001738/06, a registered Long-Term Insurer and administered by Smart Care Solutions (Pty) Ltd, a registered Financial Services Provider (FSP: 35166)')), React.createElement(Container, null, React.createElement(Stripes, null, React.createElement(Stripe, {
    colour: '#861B2B'
  }), React.createElement(Stripe, {
    colour: '#96202F'
  }), React.createElement(Stripe, {
    colour: '#A7212D'
  }), React.createElement(Stripe, {
    colour: '#C22937'
  }), React.createElement(Stripe, {
    colour: '#DB4134'
  }), React.createElement(Stripe, {
    colour: '#E15F33'
  }), React.createElement(Stripe, {
    colour: '#E87D34'
  }), React.createElement(Stripe, {
    colour: '#D6445B'
  }), React.createElement(Stripe, {
    colour: '#9C274A'
  }), React.createElement(Stripe, {
    colour: '#761A39'
  }), React.createElement(Stripe, {
    colour: '#590D31'
  }), React.createElement(Stripe, {
    colour: '#491028'
  }))));
};

export default ABSA_Footer;